import { Stack, Typography } from "@mui/material"
import { ReactElement } from "react"

import { displayText } from "../../utils/general/generalUtils"

type KeyValueType = {
    [key: string]: string | undefined | number | boolean | null
}

interface IStackedKeyValueListProps {
    details: KeyValueType
    spacing?: number
    overrideColour?: string
}

/**
 * Displays key value pairs as a stacked vertical list. Useful for mobile layouts.
 * Spacing can be optionally configured or removed.
 */
const StackedKeyValueList = ({
    details,
    spacing,
    overrideColour,
}: IStackedKeyValueListProps): ReactElement => (
    <Stack spacing={spacing}>
        {Object.keys(details).map((key: string) => (
            <div key={key}>
                <Typography
                    color={overrideColour ?? "text.secondary"}
                    variant="body2"
                >
                    {key}
                </Typography>
                <Typography
                    color={overrideColour ?? "text.primary"}
                    fontWeight="500"
                >
                    {displayText(details[key])}
                </Typography>
            </div>
        ))}
    </Stack>
)

StackedKeyValueList.defaultProps = {
    spacing: 1,
    overrideColour: undefined,
}

export default StackedKeyValueList
